import script from "./generateResults.vue?vue&type=script&setup=true&lang=js"
export * from "./generateResults.vue?vue&type=script&setup=true&lang=js"

import "./generateResults.vue?vue&type=style&index=0&id=36ca6c92&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36ca6c92"]])

export default __exports__